import { type LayoutContainerWidth } from 'noddi-ui-web';
import { createContext } from 'react';

/** A page canvas other than the layout's default. `grouped`: the worker app's screen color, for white cards. */
export type PageBackground = 'grouped';

type PageLayoutContextValue = {
  width: LayoutContainerWidth | undefined;
  setWidth: (width: LayoutContainerWidth | undefined) => void;
  background: PageBackground | undefined;
  setBackground: (background: PageBackground | undefined) => void;
};

export const PageLayoutContext = createContext<PageLayoutContextValue | null>(null);
